import React from 'react'
import Appointment from '../components/Appointment/Appointment'

function AppointmentPage() {
  return (
    <Appointment />
  )
}

export default AppointmentPage